import { uniq } from 'lodash';
import states from './states';

const update = (items, u) => {
  const result = uniq(u(items));

  return {
    totalCount: result.length,
    result,
  };
};

export default ({
  GET_LIST,
  GET_ADMIN_LIST,
  DELETE,
  UPDATE,
  GET,
  GET_ADMIN,
  CREATE,
  GET_POSTS_FOR_ACCOUNT,
  CHANGE_SORT_ORDER,
}) => ({
  [GET_LIST]: (_, payload) => ({
    result: payload.normalized.result,
    totalCount: payload.normalized.result.length,
    status: states.loaded,
  }),
  [GET_ADMIN_LIST]: (_, payload) => ({
    result: payload.normalized.result,
    totalCount: payload.normalized.result.length,
    status: states.loaded,
  }),
  [DELETE]: ({ result, ...state }, _, meta) => ({
    ...state,
    ...update(result, i => i.filter(x => x !== meta.id)),
    status: states.loaded,
  }),
  [CREATE]: ({ result, ...state }, payload) => ({
    ...state,
    ...update(result, i => [...i, payload.id]),
    status: states.loaded,
  }),
  [UPDATE]: ({ result, ...state }, payload) => ({
    ...state,
    ...update(result, i => [...i, payload.id]),
    status: states.loaded,
  }),
  [GET]: ({ result, ...state }, payload) => ({
    ...state,
    ...update(result, i => [...i, payload.id]),
    status: states.loaded,
  }),
  [GET_ADMIN]: ({ result, ...state }, payload) => ({
    ...state,
    ...update(result, i => [...i, payload.id]),
    status: states.loaded,
  }),
  [GET_POSTS_FOR_ACCOUNT]: ({ ...state }, payload) => ({
    ...state,
    retrievedResult: payload,
    totalRetrievedPostCount: payload.length,
    status: states.loaded,
  }),
  [CHANGE_SORT_ORDER]: (_, payload) => ({
    result: payload.normalized.result,
    totalCount: payload.normalized.result.length,
    status: states.loaded,
  }),
  default: state => state,
});
